module.exports = __webpack_public_path__ + "static/media/apartment20.341c972f.jpg";